<ion-header id="header">
  <ion-toolbar>
    <ion-title>
      GPS Tracking
    </ion-title>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        @if (modeService.isIosMode()) {
        <div>Schliessen</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="close-outline"
            slot="icon-only"
            size="large"
          ></ion-icon>
        </div>
        }
      </ion-button>
    </ion-buttons>
    @if (isLoading()) {
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    }
  </ion-toolbar>
</ion-header>
<ion-content padding>
  <div class="map" #map></div>
  
  <div class="tracking-button-container">
    @if (!maps.isTracking) {
      <ion-button expand="block" color="primary" (click)="startTracking()" class="tracking-button">
        <ion-icon name="locate-outline" slot="start"></ion-icon>
        GPS-Tracking starten
      </ion-button>
    } @else {
      <ion-button expand="block" color="danger" (click)="stopTracking()" class="tracking-button">
        <ion-icon name="stop-circle-outline" slot="start"></ion-icon>
        GPS-Tracking beenden
      </ion-button>
    }
  </div>
</ion-content>